"use strict";

// This scotch tapes an issue where SSR wont work with Drawers
var tsxSafeGlobal = global;
if (tsxSafeGlobal && tsxSafeGlobal.Element === undefined) {
  tsxSafeGlobal.Element = function () {};
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@rmwc/drawer/polyfill.js
// module id = 461
// module chunks = 0